export default __webpack_public_path__ + "1ffbfd99cdd62b3c9a523d9ba752b7f5.png";